// Behavioural port of AI SDK Elements' Reasoning / Chain-of-Thought (Apache-2.0, Copyright Vercel); patterns only.

import type { Component } from 'vue'
import {
  ArrowRightIcon,
  BinocularsIcon,
  BotIcon,
  BrainIcon,
  FileTextIcon,
  GlobalIcon,
  PenIcon,
} from '@solar-icons/vue/linear'
import type { AgentCopyParams, AgentLabelKey, AgentSource } from '@/types/chat'

export type ActivityStatus = 'pending' | 'active' | 'complete' | 'failed'

export type ActivityKind =
  | 'thinking'
  | 'web-search'
  | 'research'
  | 'drafting'
  | 'editing'
  | 'generating'
  | 'navigating'

export interface ActivityItem {
  id: string
  kind: ActivityKind
  labelKey?: AgentLabelKey
  labelParams?: AgentCopyParams
  description?: string
  status: ActivityStatus
  /** What the step read, as its tool result reported it. Absent while it runs or when it read nothing. */
  sources?: readonly AgentSource[]
}

export function isFinished(status: ActivityStatus): boolean {
  return status === 'complete' || status === 'failed'
}

/** Icon and i18n verb key for each {@link ActivityKind}; the verb shows while a step has no explicit label. */
export const ACTIVITY_KIND_META: Record<ActivityKind, { icon: Component; labelKey: string }> = {
  thinking: { icon: BrainIcon, labelKey: 'chat.activity.thinking' },
  'web-search': { icon: GlobalIcon, labelKey: 'chat.activity.webSearch' },
  research: { icon: BinocularsIcon, labelKey: 'chat.activity.research' },
  drafting: { icon: FileTextIcon, labelKey: 'chat.activity.drafting' },
  editing: { icon: PenIcon, labelKey: 'chat.activity.editing' },
  generating: { icon: BotIcon, labelKey: 'chat.activity.generating' },
  navigating: { icon: ArrowRightIcon, labelKey: 'chat.activity.navigating' },
}
